module.exports = __webpack_public_path__ + "media/site/images/banners/banner-solutions-mobile-38a9f9ed8b113921563536cc51263969.svg";